import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { Select, SelectItem } from '~/ui/core/select/Select';

import type { GrowthCompanyGoal } from '../../data-contract/growth';
import { htmlToPlainText } from './goal-display';

export const NO_COMPANY_GOAL = 'none';

export const CompanyGoalSummary: FunctionComponent<{ readonly goal: GrowthCompanyGoal }> = ({ goal }) => (
    <span className="flex flex-col gap-xxs py-xxs text-left">
        <span className="text-body-s text-text-heading">{goal.title}</span>
        <span className="line-clamp-2 text-body-xs text-pretty text-text-secondary">
            {htmlToPlainText(goal.description)}
        </span>
    </span>
);

export const CompanyGoalPicker: FunctionComponent<{
    readonly companyGoals: readonly GrowthCompanyGoal[];
    readonly disabled?: boolean;
    readonly onChange: (paysIntoId: string | null) => void;
    readonly value: string | null | undefined;
}> = ({ companyGoals, disabled, onChange, value }) => {
    const translate = useTranslate();

    return (
        <Select
            aria-label={translate('pages.growth.form.pays-into-label')}
            disabled={disabled}
            value={value ?? NO_COMPANY_GOAL}
            onValueChange={(next) => onChange(next === NO_COMPANY_GOAL ? null : next)}
        >
            <SelectItem value={NO_COMPANY_GOAL}>
                <span className="py-xxs text-body-s text-text-secondary">
                    {translate('pages.growth.form.no-company-goal')}
                </span>
            </SelectItem>
            {companyGoals.map((companyGoal) => (
                <SelectItem key={companyGoal.id} value={companyGoal.id}>
                    <CompanyGoalSummary goal={companyGoal} />
                </SelectItem>
            ))}
        </Select>
    );
};
